<!--TODO need to somehow inform user that country code is needed before typing phone number...-->
<div [formGroup]="formGroup" class="phone-fields-wrappers">
	<mat-form-field
		hideRequiredMarker
		class="country-code-form-field"
		floatLabel="{{ floatLabelConfig }}"
	>
		<mat-label>{{ 'code' | translate }}</mat-label>
		<input
			type="text"
			placeholder="+xxx"
			aria-label="Number"
			matInput
			[readonly]="codeIsReadOnly"
			formControlName="countryCode"
			[matAutocomplete]="auto"
		/>
		<mat-autocomplete
			#auto="matAutocomplete"
			panelWidth="200px"
			class="nice-scroll colored-scroll-track visible-scroll"
		>
			@for (option of filteredOptions$ | async; track option) {
				<mat-option [value]="option.dial_code">
					{{ option.dial_code }} {{ option.name }}
				</mat-option>
			}
		</mat-autocomplete>
		<mat-error>
			@if (countryCodeControl.hasError('required')) {
				<span>
					{{ 'required' | translate }}
				</span>
			}
			@if (countryCodeControl.hasError('invalid_code')) {
				<span>{{ 'invalid_code' | translate }}</span>
			}
		</mat-error>
	</mat-form-field>
	<mat-form-field
		hideRequiredMarker
		class="phone-form-field"
		floatLabel="{{ floatLabelConfig }}"
	>
		<mat-label>{{ 'phone' | translate }}</mat-label>
		<input
			[formControlName]="phoneNameAlias"
			matInput
			[readonly]="phoneIsReadOnly"
			[placeholder]="selectedCountryCodeObject?.placeholder || 'xxx xxx xxx'"
			[dropSpecialCharacters]="[' ']"
			[mask]="selectedCountryCodeObject?.mask"
			type="text"
		/>
		<mat-error>
			@if (phoneControl.hasError('required')) {
				<span class="phone-required-error">
					{{ 'required' | translate }}
				</span>
			}
			@if (phoneControl.hasError('mask')) {
				<span>
					{{ 'needs_to_be_like' | translate }}
					{{ selectedCountryCodeObject?.placeholder }}
				</span>
			}
		</mat-error>
	</mat-form-field>
</div>
